// extracted by mini-css-extract-plugin
export var copyableField = "_ih-4";
export var customerBadge = "_ih-0";
export var customerInfoTitle = "_ih-2";
export var details = "_ih-1";
export var dropdownContainer = "_ih-5";
export var dropdownImage = "_ih-6";
export var editAssigneeForm = "_ih-a";
export var editButton = "_ih-3";
export var email = "_ih-7";
export var hidden = "_ih-d";
export var input = "_ih-8";
export var saveButton = "_ih-b";
export var shopifyIcon = "_ih-c";
export var suggestionBadge = "_ih-e";
export var suggestionText = "_ih-f";
export var username = "_ih-9";